import { render, staticRenderFns } from "./RegisterModuleCustomization.vue?vue&type=template&id=6a2763fa&"
import script from "./RegisterModuleCustomization.vue?vue&type=script&lang=js&"
export * from "./RegisterModuleCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports